export const domLoaded = ( listener: EventListenerOrEventListenerObject ) => 
{
    globalThis.addEventListener("DOMContentLoaded", listener);
}